import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../auth/AuthProvider";
import { useParams } from "react-router-dom";

export default function PhaseQuestions({ id11 }) {
  const [showPhase1, setShowPhase1] = useState({
    id1: 0,
    show: false,
  });

  const [question, setQuestion] = useState([]);
  const [phase, setPhase] = useState({});

  const { apiUrl } = useContext(AuthContext);
  const { id } = useParams();

  useEffect(() => {
    axios
      .get(`${apiUrl}/question/byPhaseAndTheme/Phase 5/${id}`)
      .then((response) => {
        setQuestion(response.data.sort((a, b) => a.id - b.id));
      })
      .catch((err) => {});

    axios
      .get(`${apiUrl}/phase/${id11}`)
      .then((response) => {
        setPhase(response.data);
        // setPhase(response.data.sort((a, b) => a.id - b.id));
      })
      .catch((err) => {});
  }, []);
  function phaseClick1(id11) {
    setShowPhase1((prevState) => ({
      id1: id11,
      show: !prevState.show,
    }));
  }

  return (
    <>
      <button
        className="phaseSection p1Sec phaseSectionDisabled"
        onClick={() => phaseClick1(id11)}
        type="button"
      >
        <div className="phaseTrack">
          <div className="phase-status-badge locked">
            <img src="/lock.png" alt="lock" width={10} height={10} /> LOCKED
          </div>

          {showPhase1.show && showPhase1.id1 === id11 ? (
            <div
              className="arrowHead upward"
              role="button"
              tabIndex={0}
              style={{
                color: "rgba(242, 237, 229, 0.78)",
                fontFamily: "sans-serif",
              }}
            >
              ⌵
            </div>
          ) : (
            <div
              className="arrowHead downward"
              role="button"
              tabIndex={0}
              style={{
                color: "rgba(242, 237, 229, 0.78)",
                fontFamily: "sans-serif",
              }}
            >
              ⌵
            </div>
          )}
        </div>

        <div className="phaseArrowHeadParent">
          <h2 className="phase-title">
            {phase.title}: {phase.name}
            {/* {phase.map((p) => {
              p.id === id11 && p.title + ":" + p.name;
            })} */}
          </h2>
        </div>

        <div
          // style={{ color: "rgba(242, 237, 229, 0.78)" }}
          className="phaseSectionParagraph phase-desc"
        >
          {phase.description}
          <div className="progressLineParent">
            <div className="progressLineChild" style={{ width: "0" }}></div>
          </div>
        </div>
        <p className="phase-progress-count">0/5</p>
      </button>
      {showPhase1.show && showPhase1.id1 === id11 && (
        <div className="phaseSecParent">
          <button className="phaseSecChild p1q1 q1" disabled>
            Session {question[0]?.questionNumber}
            <span className="locked-span">
              <img src="/lock.png" alt="lock" width={10} height={10} />
              LOCKED
            </span>
          </button>

          <button className="phaseSecChild p1q1 q2" disabled>
            Session {question[1]?.questionNumber}
            <span className="locked-span">
              <img src="/lock.png" alt="lock" width={10} height={10} />
              LOCKED
            </span>
          </button>

          <button className="phaseSecChild p1q1 q3" disabled>
            Session {question[2]?.questionNumber}
            <span className="locked-span">
              <img src="/lock.png" alt="lock" width={10} height={10} />
              LOCKED
            </span>
          </button>

          <button className="phaseSecChild p1q1 q4" disabled>
            Session {question[3]?.questionNumber}
            <span className="locked-span">
              <img src="/lock.png" alt="lock" width={10} height={10} />
              LOCKED
            </span>
          </button>

          <button className="phaseSecChild p1q1 q5" disabled>
            Session {question[4]?.questionNumber}
            <span className="locked-span">
              <img src="/lock.png" alt="lock" width={10} height={10} />
              LOCKED
            </span>
          </button>
        </div>
      )}
    </>
  );
}
